"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAnnuityOptions = void 0;
const common_1 = require("../common");
function validateAnnuityOptions(options) {
    const errors = [];
    errors.push(...common_1.validatePositiveNumber(options.numberOfPayments, 'numberOfPayments'));
    errors.push(...common_1.validatePositiveNumber(options.amount, 'amount'));
    return {
        isValid: errors.length === 0,
        errors,
    };
}
exports.validateAnnuityOptions = validateAnnuityOptions;
//# sourceMappingURL=annuity-options-validator.js.map